// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__Nf7No","rootSuccess":"CompleteLink_rootSuccess__32OBU","rootFailure":"CompleteLink_rootFailure__3vbVz","isDisabled":"CompleteLink_isDisabled__1HqBq"};